import React, { useEffect, useState } from "react";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import dayjs from "dayjs";
import "../App.css";
import GoogleMapCntrLoc from "./GoogleMapCntrLoc";
import DownloadExcel from "./main/DownloadExcel";

import * as XLSX from "xlsx";
import { APIBaseURL } from "../Config";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";
import { Link } from "react-router-dom";

export default function Containers() {
  const [Data, setData] = useState([]);
  const [ModalData, setModalData] = useState("");

  const [containersData, setContainersData] = useState(null);
  const [containerNo, setContainerNo] = useState(null);
  const [sline, setSline] = useState('');
  const [loading, setLoading] = useState(null);
  const [MapViewData, setMapViewData] = useState(null);

  const handleFileUpload = (event) => {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const data = XLSX.utils.sheet_to_json(worksheet);
        const containerNos = data.map((item) => item.CTR_NO);
        fetchContainerDetailsArray(containerNos);
      };
      reader.readAsBinaryString(file);
    }
  };

  const handelForm = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formValues = Object.fromEntries(formData.entries());
    setContainerNo(formValues.containerNo);
    setSline(formValues.sline);
  };

  

  const fetchContainerDetailsArray = async (value) => {
    const data = [];
    setContainersData(data.data);
  };

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/yard/containers?page=${page}`;
    if (containerNo) {
      url += `&container_no=${containerNo}`;
    }
    if(sline){
      url+=`&sline=${sline}`;
    }

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };


  // const handleDownload = () => {
  //   DownloadExcel(Data?.data, ['rn'], "container_Reports",[]);
  // };

  const handleDownload = async () => {
    setLoading(true); 
  
    try {
      let allData = [];
      let page = 1;
      let hasMoreData = true;
  
      while (hasMoreData) {
        let url = `${APIBaseURL}/get/yard/containers?page=${page}`;
        if (containerNo) url += `&container_no=${containerNo}`;
        if (sline) url += `&sline=${sline}`;
        setLoading(true); 
        const response = await axios.get(url);
        if (response.data && response.data.status === "success") {
          const pageData = response.data.data?.data || [];
          allData = allData.concat(pageData);
  
          const currentPage = response.data.data?.current_page || page;
          const lastPage = response.data.data?.last_page || page;
  
          hasMoreData = currentPage < lastPage;
          page++;
        } else {
          throw new Error("Something went wrong while fetching data.");
        }
      }
  
      if (allData.length > 0) {
        DownloadExcel(allData, ['rn'], "container_Reports", []);
      } else {
        Swal.fire({
          icon: "info",
          text: "No data found to export.",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error fetching data: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      // Ensure this always runs last
      setLoading(false);
    }
  };


  const GetModalData = async (container_no, id) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/yard/container/info/${container_no}?master_id=${id}`;
    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setModalData(response.data.data);
      } else {
        setModalData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [containerNo,sline]);
  let myId=1;

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row justify-content-between my-3">
                  <div className="card">
                    <div className="card-body">
                <h3 className="text-primary">Know Your Container Location</h3>
                      <form className="needs-validation" onSubmit={handelForm}>
                        <div className="row align-items-center">
                          <div className="col-md-3 mb-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                id="containerNo"
                                name="containerNo"
                              />
                              <label htmlFor="container-name">
                                Container Number
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                id="sline"
                                name="sline"
                              />
                              <label htmlFor="sline">
                              Shipping Line 
                              </label>
                            </div>
                          </div>
                          <div className="col-md-4 mb-2">
                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>

                            <button
                              type="button"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                              onClick={handleDownload}
                            > <i className="ri-download-line ri-20px" />
                            </button>
                            

                            <button
                              type="submit"
                              className="btn btn-label-primary waves-effect waves-light me-1"
                              onClick={() => window.location.reload()}
                            >
                              <i className="ri-restart-line ri-20px" />
                            </button>
                            <div className="d-inline mb-3">
                              <input
                                type="file"
                                accept=".xls,.xlsx"
                                hidden
                                id="file"
                                onClick={(e) => (e.target.value = "")}
                                // onChange={handleFileUpload}
                              />
                              <label htmlFor="file">
                                <span className="btn btn-label-primary">
                                  <i className="ri-20px ri-upload-cloud-line"></i>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                     
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>Serial No.</td>
                              <td>Container No.</td>
                              <td>Container Size</td>
                              <td>Container Type</td>
                              <td>Sline</td>
                              <td>Location</td>
                              <td>In From</td>
                              <td>In Time</td>
                              {/* <td>Action</td> */}
                            </tr>
                          </thead>

                          {/* {Array.isArray(containersData) &&
                          containersData.length > 0 ? ( */}

                          <tbody>
                            {Data?.data?.map((container, i) => {
                              if(container.last_stk_loc || container.active_jobs != null){
                              return (
                                <tr key={i}>
                                  <td 
                                    data-bs-toggle="modal"
                                    data-bs-target="#ModalView"
                                    onClick={() =>
                                      GetModalData(
                                        container.container_no,
                                        container.id
                                      )
                                    }
                                  >
                                    <span>{myId++}</span>
                                  </td>
                                  <td>
                                    <span>{container.container_no}</span>
                                  </td>
                                  <td>
                                    <span>{container.container_size}</span>
                                  </td>
                                  <td>
                                    <span>{container.type}</span>
                                  </td>
                                  <td>
                                    <span>{container?.slinecode}</span>
                                  </td>
                                  <td>
                                    <span>{container.last_stk_loc || (container.active_jobs != null ? 'Job in queue' : 'N/A')}</span>
                                    {/* ModalViewMap */}
                                    {container.last_stk_loc &&
                                     ( /\d+\/\d+/.test(
                                        container.last_stk_loc
                                      ) ||  container.last_stk_loc=='PATH')  ? (
                                        <a
                                          href="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#ModalViewMap"
                                            className=""
                                          onClick={() =>
                                            setMapViewData(container.last_lat_long)
                                          }
                                          >
                                              <i className="ri-map-pin-line ri-24px"></i>
                                          </a>
                                      ) : '' }
                                      
                                      {/* {container.last_stk_loc &&
                                      /\d+\/\d+/.test(
                                        container.last_stk_loc
                                      ) ? (
                                        <a
                                          href={`/stackView/${container.last_stk_loc
                                            .replace("/", "-")
                                            .slice(0, -1)}?container=${
                                            container.container_no
                                          }`}
                                          className=""
                                        >
                                          <i className="ri-map-pin-line ri-24px"></i>
                                        </a>
                                      ) : null} */}
                                    

                                  </td>
                                  <td>
                                    <span>{container.in_from}</span>
                                  </td>
                                  <td>
                                    <span>{formatToDateTime(container.in_time)}</span>
                                  </td>
                                  
                                  {/* <td>
                                    <button
                                      className="btn btn-label-primary btn-sm mx-1"
                                      data-bs-toggle="modal"
                                      data-bs-target="#ModalView"
                                      onClick={() =>
                                        GetModalData(
                                          container.container_no,
                                          container.id
                                        )
                                      }
                                    >
                                      <i className="ri-eye-line ri-22px"></i>
                                    </button>
                                  </td> */}
                                </tr>
                              );

                            }})}
                          </tbody>
                        </table>
                        {Data && Data.data && (
                          <div className="container mt-4">
                            <div className="row">
                              <div className="col-sm-12 col-md-6">
                                <div
                                  className="dataTables_info"
                                  id="DataTables_Table_0_info"
                                  role="status"
                                  aria-live="polite"
                                >
                                  Showing {Data.from} to {Data.to} of{" "}
                                  {Data.total} entries
                                </div>
                              </div>
                              <div className="col-10 m-auto mt-2">
                                <div
                                  className="dataTables_paginate paging_simple_numbers"
                                  id="DataTables_Table_0_paginate"
                                >
                                  <ul className="pagination ">
                                    {Data &&
                                      Data.links &&
                                      Data.links.map((link, q) => {
                                        let showData =
                                          Data.links.length == q + 1
                                            ? "Next"
                                            : q == 0
                                            ? "Previous"
                                            : link.label;
                                        return (
                                          <li
                                            key={q}
                                            className={`paginate_button page-item ${
                                              link.active === true
                                                ? "active"
                                                : ""
                                            }  ${
                                              showData == "Next" &&
                                              Data.current_page ==
                                                Data.last_page
                                                ? "disabled"
                                                : showData == "Previous" &&
                                                  Data.current_page == 1
                                                ? "disabled"
                                                : ""
                                            } `}
                                          >
                                            <button
                                              onClick={() => {
                                                showData == "Previous"
                                                  ? GetData(
                                                      Data.current_page - 1
                                                    )
                                                  : showData == "Next"
                                                  ? GetData(
                                                      Data.current_page + 1
                                                    )
                                                  : GetData(link.label);
                                              }}
                                              aria-controls="DataTables_Table_0"
                                              role="link"
                                              aria-current="page"
                                              data-dt-idx={0}
                                              tabIndex={0}
                                              className="page-link"
                                            >
                                              {showData}
                                            </button>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="ModalView"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Container Details
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setModalData("")}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table table-hover table-font table-striped">
                            <tbody>
                              <tr>
                                <th>Container No</th>
                                <td>{ModalData?.container_no}</td>
                              </tr>
                              <tr>
                                <th>Size</th>
                                <td>{ModalData?.container_size}</td>
                              </tr>
                              <tr>
                                <th>Type</th>
                                <td>{ModalData?.type}</td>
                              </tr>
                              <tr>
                                <th>In Time</th>
                                <td>{formatToDateTime(ModalData?.in_time)}</td>
                              </tr>
                            </tbody>
                          </table>

                          {ModalData?.in_gate_data && (
                            <>
                              <h5>Gate IN Data</h5>
                              <table className="table table-hover table-font table-striped">
                                <tbody>
                                  <tr>
                                    <th>Gate No</th>
                                    <td>{ModalData?.in_gate_data.gate_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Vehicle No</th>
                                    <td>
                                      {ModalData?.in_gate_data.vehicle_no}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Permit No</th>
                                    <td>{ModalData?.in_gate_data.permit_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Container Status</th>
                                    <td>
                                      {ModalData?.in_gate_data.containerstatus}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}

                          {ModalData.in_rake_data && (
                            <>
                              <h5>Rake In Data</h5>
                              <table className="table table-hover table-font table-striped">
                                <tbody>
                                  <tr>
                                    <th>Train No</th>
                                    <td>{ModalData?.in_rake_data.train_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Track</th>
                                    <td>{ModalData?.in_rake_data.track}</td>
                                  </tr>
                                  <tr>
                                    <th>Wagon No</th>
                                    <td>{ModalData?.in_rake_data.wagon_no}</td>
                                  </tr>
                                  <tr>
                                    <th>Seal No</th>
                                    <td>{ModalData?.in_rake_data.seal_1_no}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}

                          <h5>Transactions</h5>
                          <div className="table-responsive">
                          <table className="table table-hover table-font table-striped">
                            <thead>
                              <tr>
                                <th>SN</th>
                                <th>Equipment</th>
                                <th>Source</th>
                                <th>Source Time</th>
                                <th>Destination</th>
                                <th>Dest Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ModalData?.transactions?.map((txn, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{txn?.equipmentid}</td>
                                  <td>{txn?.locklocation}</td>
                                  <td>{formatToDateTime(txn?.lockdatetime)}</td>
                                  <td>{txn?.unlocklocation}</td>
                                  <td>
                                    {formatToDateTime(txn?.unlockdatetime)}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={() => setModalData("")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>



              <div
                className="modal fade"
                id="ModalViewMap"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Container Details
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        // onClick={() => setModalData("")}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          {MapViewData}
                              <GoogleMapCntrLoc lat_long={MapViewData} />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        // onClick={() => setModalData("")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
